import { EntityModules, LIBRARY_ENTITY_MODULES } from 'core/constants';

import SessionUser from 'stores/Session/SessionUser';

import { canEditLibrary } from 'utils/roles/permissions';

export const canEditEntity = (type: EntityModules, user?: SessionUser | null, archived = false): boolean =>
  LIBRARY_ENTITY_MODULES.includes(type)
    ? canEditLibrary(user ?? null) && !user?.readOnly && !archived
    : !user?.readOnly;
